Vue.component('list', {
    props: ['endpoint'],
    data() {
        return {
            pagination : {},
            loaded: false,
            loadingMore: false,
            query: null,
            activeQuery : null,
        }
    },
    methods: {
        loadItems() {
            this.loaded = false;
            axios.get(this.endpoint, { params: { ajax : true, search_query : this.activeQuery }})
                 .then(response => {
                    this.pagination = response.data;
                    this.loaded = true;
                 });
        },
        search() {
            this.activeQuery = this.query;
            this.loadItems();
        },
        goTo(url) {
            window.location = url;
        },
        loadMore() {
            this.loadingMore = true;
            axios.get(this.endpoint, { params: { ajax : true, page : this.pagination.current_page +1, search_query : this.activeQuery }})
                 .then(response => {
                    this.pagination.current_page = this.pagination.current_page + 1;
                    response.data.data.forEach(model => {
                        this.pagination.data.push(model);
                        this.loadingMore = false;
                    });
                 });
        },
        confirmDuplication(item) {
            this.$swal({
              title: 'Duplicate record?',
              text: "Please confirm your wish to duplicate this record",
              icon: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#6dc192',
              cancelButtonColor: '#3085d6',
              confirmButtonText: 'Yes, duplicate!'
            }).then((result) => {
                if (result.value) {
                    axios.post(this.endpoint +'/'+ item.id +'/duplicate')
                         .then(response => {
                            this.loadItems();
                         });
                }
            });
        },
        confirmDelete(item, row) {
            this.$swal({
              title: 'Are you sure?',
              text: "Deleting this item can not be undone",
              icon: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#d33',
              cancelButtonColor: '#3085d6',
              confirmButtonText: 'Yes, delete it!'
            }).then((result) => {
                if (result.value) {
                    axios.delete(this.endpoint +'/'+ item.id)
                         .then(response => {
                            this.pagination.data.splice(row, 1);
                            this.pagination.total--;
                         });
                }
            });
        }
    },
    mounted() {
        this.loadItems();
    }
});